import { StyleProvider } from "@ant-design/cssinjs";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/sentry";
import App from "@/App";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

root.render(
  <React.StrictMode>
    {/* antd emits its CSS-in-JS unlayered by default, which beats every
        Tailwind utility regardless of specificity (see globals.css). `layer`
        makes it emit into the `antd` layer declared there instead. */}
    <StyleProvider layer>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </StyleProvider>
  </React.StrictMode>,
);
